import * as React from 'react';
import { Grid, StyledComponentProps } from '@material-ui/core';
import TextField from '../../../../ui-components/TextField/TextField';

interface IProps extends StyledComponentProps {
    handleChangeBirthDay: (val: string) => void;
    birthDay?: string;
    loading: boolean;
    classes: any;
}


export const Filters = (props: IProps) => {
    const classes = props.classes;
    return (
        <Grid container xs={12} className={classes.root} spacing={2}>
            <Grid item xs={12} sm={4} >
                <TextField label='Filtro giorno'
                    onKeyDown={(e) => {
                        //Enter KeyCode = 13
                        if (e.keyCode === 13) {
                            props.handleChangeBirthDay(props.birthDay)
                        }
                    }}
                    disabled={props.loading}
                    onChange={props.handleChangeBirthDay}
                    value={props.birthDay} />
            </Grid>
            {/* <Grid item xs={3} sm={2} className={classes.searchButtons} >
                <div className={classes.searchButton}>
                    <Button className={classes.searchButton} onClick={() => props.search(props.fullnameOrEmail, props.selctedTag)}>Cerca</Button>
                </div>
            </Grid> */}
        </Grid>
    );
}
